<template lang="pug">
	.audio-tracker-fade-control(@mousemove="onMouseMove", @mouseup="onMouseUp", @mousedown="onFadeMouseDown", @dblclick.stop)
		svg(height="100%" width="100%", :id="`fade_${track.id}`")
			line.fade-line(v-bind="startLine")
			polygon.fade-triangle(:points="startLine.polygon")
			rect.fade-handler(v-bind="startLine.rect", @mousedown="e => onHandlerMouseDown(e, 'start')")
			line.fade-line(v-bind="endLine")
			polygon.fade-triangle(:points="endLine.polygon")
			rect.fade-handler(v-bind="endLine.rect", @mousedown="e => onHandlerMouseDown(e, 'end')")
</template>


<script>
	import VueTypes from 'vue-types';
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'audioTracker.AudioTracker',
		name: 'audio-tracker-fade-control',
		components: { Loader },
		props: {
			track: VueTypes.object.def(null),
			tracker: VueTypes.object.def(null),
		},
		data() {
			return {
				isMovingPoint: null,
				isMouseDown: false,
				fade: {
					start: 0,
					end: 0
				}
			}
		},
		computed: {
			fadeIn() {
				return this.fade.start;
			},
			fadeOut() {
				return this.fade.end;
			},
			startLine() {
				let points = {
					x1: this.fadeIn * this.pps,
					y1: 0,
					x2: this.fadeIn * this.pps,
					y2: this.height
				}

				let size = 10;
				let coef = 0.75;
				points.polygon = `${points.x1 - size * coef},${points.y1} ${points.x1 + size * coef},${points.y1} ${points.x1},${points.y1 + size}`;

				points.rect = {
					x: points.x1 - size * 2,
					y: points.y1,
					width: size * 4,
					height: this.height
				}

				return points;
			},
			endLine() {
				let points = {
					x1: this.width - (this.fadeOut * this.pps),
					y1: 0,
					x2: this.width - (this.fadeOut * this.pps),
					y2: this.height
				}

				let size = 10;
				let coef = 0.75;
				points.polygon = `${points.x1 - size * coef},${points.y1} ${points.x1 + size * coef},${points.y1} ${points.x1},${points.y1 + size}`;

				points.rect = {
					x: points.x1 - size * 2,
					y: points.y1,
					width: size * 4,
					height: this.height
				}

				return points;
			},
			width() {
				return this.track.trimmedDuration * this.pps;
			},
			height() {
				return this.track.__canvasHeight;
			},
			pps() {
				return this.tracker.display.pixelsPerSecond;
			},
		},
		watch: {
			points: {
				handler() {
					this.$save();
				},
				deep: true
			}
		},
		mounted() {
			this.$onMouseMove = (e) => {
				this.onMouseMove(e, this);
			}

			document.addEventListener('mousedown', this.onMouseDown);
			document.addEventListener('mousemove', this.$onMouseMove);

			this.$eventsBus.$on('tracker-tool-fade-change', this.onGlobalFadeChange);
			
			if (__DEBUG__)
				window.fadeControl = this;

			this.init();
		},
		destroyed() {
			document.removeEventListener('mousedown', this.onMouseDown);
			document.removeEventListener('mousemove', this.$onMouseMove);

			this.$eventsBus.$off('tracker-tool-fade-change', this.onGlobalFadeChange);

			delete this.$onMouseMove;
		},		
		methods: {
			onGlobalFadeChange() {
				this.init();
			},
			init() {
				this.fade.start = this.track?.insertion?.JsonConfig?.fadeIn?.value || 0;
				this.fade.end = this.track?.insertion?.JsonConfig?.fadeOut?.value || 0;
			},
			onMouseDown(e) {
				e.stopPropagation();
				e.preventDefault();
			},
			onMouseMove(e, sender) {
				if (sender !== this) return;
				if (this.isMovingPoint) {
					let delta = e.movementX / this.pps;
					this.fade[this.isMovingPoint] = Math.max(0, this.fade[this.isMovingPoint] + (this.isMovingPoint === 'start' ? 1 : -1) * delta);
				}

				e.stopPropagation();
				e.preventDefault();
			},
			onHandlerMouseDown(e, handler) {
				this.isMovingPoint = handler;
				this.$movingPointInitialPositon = { x: e.offsetX, y: e.offsetY };
				e.stopPropagation();
				e.preventDefault();
			},
			onFadeMouseDown(e) {
				this.isMouseDown = true;
				
				e.stopPropagation();
				e.preventDefault();
			},
			onMouseUp(e) {
				this.isMovingPoint = null;
				this.isMouseDown = false;

				if (this.fade.start !== this.track?.insertion?.JsonConfig?.fadeIn?.value || this.fade.end !== this.track?.insertion?.JsonConfig?.fadeOut?.value) {
					this.$eventsBus.$emit('tracker-tool-fade-change', [this.fade.start, this.fade.end], 'fadeControl');
				}

				e.stopPropagation();
				e.preventDefault();
			},
		}
	}
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.audio-tracker-fade-control {
		position: absolute;
		background: #00000020;
		left: 0px;
		right: 0px;
		top: 0px;
		bottom: 0px;
		z-index: 10;
		
		.fade-line {
			stroke: $base-accent;
			stroke-width: 1px;
			padding-left: 10px;
		}

		.fade-triangle {
			fill: $base-accent;
		}

		.fade-handler {
			fill: #00000000;
			cursor: w-resize;
		}
	}
</style>
